var _this = this;
import * as tslib_1 from "tslib";
import { exitSearch } from 'owa-mail-module-orchestrator';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
import { lazySelectFolderNode } from 'owa-mail-folder-forest-actions';
import { orchestrator } from 'satcheljs';
import { searchStore as searchStoreV1 } from 'owa-mail-search-store';
import { mailSearchStore as searchStoreV2 } from 'owa-mail-search';
orchestrator(exitSearch, function (actionMessage) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var searchStore;
    return tslib_1.__generator(this, function (_a) {
        searchStore = isMailFeatureEnabled('sea-commonSearchBox') ? searchStoreV2 : searchStoreV1;
        lazySelectFolderNode.importAndExecute(searchStore.previousNode, actionMessage.actionSource);
        return [2 /*return*/];
    });
}); });
//# sourceMappingURL=exitSearchOrchestrator.js.map